module.exports = __webpack_public_path__ + "static/media/addDrivingLicense.3178f7b0.svg";